import { NgModule } from '@angular/core';
import {
  PathLocationStrategy,
  LocationStrategy,
  DatePipe,
} from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { AuthGuard } from '../core/guards/auth.guard';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import * as moment from 'moment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from '../core/interceptors/http.interceptor';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DividerModule } from 'primeng/divider';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import {
  HasPermissionDirective,
  HasAnyPermissionDirective,
} from '../core/directives/has-permission.directive';
import { AcanPermissionDirective } from '../core/directives/acan-permission.directive';
import { NotFoundComponent } from './not-found/not-found.component';

export function momentAdapterFactory() {
  return adapterFactory(moment);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    AppLayoutModule,
    ToastModule,
    HasPermissionDirective,
    HasAnyPermissionDirective,
    AcanPermissionDirective,
    NotFoundComponent,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: momentAdapterFactory,
    }),
    FullCalendarModule,
    ConfirmPopupModule,
    DividerModule,
    ConfirmDialogModule,
    DropdownModule,
    CheckboxModule,
    InputSwitchModule,
    EditorModule,
    FileUploadModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextareaModule,
    ButtonModule,
    TooltipModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    AuthGuard,
    MessageService,
    ConfirmationService,
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
